import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteLogin } from '../../login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { correctHeight, detectBody, smoothlyMenu } from "../../../app.helpers";
import { CalendarFechaNacParametros } from "../../../components/common/utils/calendarFechaNacParametros";
import { DetalleVehiculoEntity, ExtrasEntity, FormaPagoEntity } from "../datosGenerales/entities/detalle_vehiculo_entity";
import { VehiculoEntity } from "../datosGenerales/entities/vehiculo_entity";
import { RenovacionService } from "./renovacion.service";
import { UtilService } from "../../../components/common/utils/util.service";
import { EspecificacionVehiculoEntity } from "../../../components/common/utils/entities/especificacionesVehiculo";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";
import { DatosGeneralesService } from "../datosGenerales/datos-generales.service";
import { ClienteIndividualEntity } from "../datosGenerales/entities/datos_generales_individual_entity";
import { SessionStorageService } from "ngx-webstorage";
import { UsuarioLoginEntity } from "../../login/usuario_login_entity";

const swal = require("sweetalert2");

declare var jQuery: any;

@Component({
    selector: 'renovacionVehiculo',
    providers: [RenovacionService],
    templateUrl: 'renovacion-vehiculo.template.html',
    styleUrls: ["renovacion.style.css"]
})

export class RenovacionVehiculo implements OnInit {
    usuario: ClienteLogin;
    vehiculoEntity: VehiculoEntity;
    vehiculoDetalleOriginal: DetalleVehiculoEntity;
    vehiculoDetalleModificado: DetalleVehiculoEntity;
    marcas: EspecificacionVehiculoEntity[];
    modelos: EspecificacionVehiculoEntity[];
    versiones: EspecificacionVehiculoEntity[];
    extrasList: EspecificacionVehiculoEntity[];
    extrasExcluidos: ExtrasEntity[];
    extrasNuevos: ExtrasEntity[];
    extraNuevoModal: ExtrasEntity;
    clienteMasivosIndividual: ClienteIndividualEntity;
    bandera: boolean;
    dedSi: number;
    formaPagoSi:number;
    deducible: boolean = false;
    vehiculoSelect: VehiculoEntity;

    @ViewChild('incluirExtra')
    modal: ModalComponent;
    editar: boolean;
    usuarioLogin: UsuarioLoginEntity;

    constructor(private renovacionService: RenovacionService,
        public utilsService: UtilService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        private consultarMasivo: ConsultarUsuarioMasivos,
        private datosGeneralesIndividualSevice: DatosGeneralesService,
        public sesionStorageService: SessionStorageService) { }

    cargaModelos(marcaCod) {
        this.versiones = null;
        this.modelos = null;
        this.utilsService.getModelos(marcaCod).subscribe(
            modelos => { this.modelos = modelos; },
            error => { this.handleError.redirectUrl(error); }
        );
    }

    cargaVersiones(modeloCod) {
        this.utilsService.getVersiones(modeloCod).subscribe(
            versiones => { this.versiones = versiones; },
            error => { this.handleError.redirectUrl(error); }
        );
    }

    ngOnInit() {
        try {
            /*correctHeight();
            detectBody();*/
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            if (this.usuario == null) {
                let error = { "status": 998, "message": "Acceso denegado" };
                this.handleError.redirectUrl(error)
            } else {

                let bandera = this.sessionTokenService.useJwtHelper();
                if (!bandera) {
                    this.consultarMasivo.iniciarUsuarioMasivo();
                    this.datosGeneralesIndividualSevice.datosClienteIndividual().subscribe(
                        datosClienteIndividual => {
                            this.clienteMasivosIndividual = datosClienteIndividual;
                            this.sesionStorageService.store("NombreUser", JSON.stringify(this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno));
                            sessionStorage.setItem("NombreUser", this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno);
                        },
                        error => { this.handleError.redirectUrl(error); });
                    this.editar = true;
                    this.vehiculoDetalleOriginal = new DetalleVehiculoEntity();
                    this.vehiculoDetalleOriginal.FormaPago= new FormaPagoEntity();
                    this.vehiculoDetalleModificado = new DetalleVehiculoEntity();
                    this.vehiculoSelect = new VehiculoEntity();
                    this.vehiculoSelect = jQuery.parseJSON(this.sesionStorageService.retrieve("VehiculoSeleccionado"));
                    this.getVehiculo();
                    this.sesionStorageService.observe("VehiculoSeleccionado").subscribe(v => {
                        this.vehiculoSelect = jQuery.parseJSON(v);
                        this.getVehiculo();
                    });
                    this.utilsService.getMarcas().subscribe(
                        marcas => { this.marcas = marcas; },
                        error => { this.handleError.redirectUrl(error); }
                    );
                    this.utilsService.getExtras().subscribe(
                        extras => this.extrasList = extras,
                        error => { this.handleError.redirectUrl(error); }
                    );
                    this.extraNuevoModal = new ExtrasEntity();
                } else {
                    this.usuarioLogin = jQuery.parseJSON(sessionStorage.getItem("usuarioLogin"));
                    let bandera = this.usuarioLogin.Tipo;
                    this.router.navigate(["/login",bandera]);
                }
            }
        } catch (e) {
            this.usuarioLogin = jQuery.parseJSON(sessionStorage.getItem("usuarioLogin"));
            let bandera = this.usuarioLogin.Tipo;
            this.router.navigate(["/login",bandera]);
        }
    }

    getVehiculo() {
        this.renovacionService.datosVehiculo(this.vehiculoSelect).subscribe(
            vehiculoDetalle => {
                this.vehiculoDetalleOriginal = vehiculoDetalle;
                this.vehiculoDetalleOriginal.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
                this.vehiculoDetalleModificado = this.cloneVehiculo(vehiculoDetalle);
                this.vehiculoDetalleModificado.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
                this.cargaModelos(this.vehiculoDetalleModificado.CodMarcaVeh);
                this.cargaVersiones(this.vehiculoDetalleModificado.CodModeloVeh);
                this.extrasExcluidos = new Array<ExtrasEntity>();
                this.extrasNuevos = new Array<ExtrasEntity>();

                if (this.vehiculoDetalleOriginal.Extras != null && this.vehiculoDetalleOriginal.Extras.length > 0) {
                    this.bandera = true;
                } else {
                    this.bandera = false;
                }
                this.dedSi = 2;
                this.formaPagoSi=1;
                if (this.vehiculoDetalleModificado.CodigoCiudadDeducible > 0 && this.vehiculoDetalleModificado.CodigoProductoDeducible > 0 && this.vehiculoDetalleOriginal.CodigoVehiculoDeducible > 0) {
                    this.deducible = true;
                } else {
                    this.deducible = false;
                }

                if(this.vehiculoDetalleModificado.EsDeducible){
                    this.deducible = false;
                }
            },
            error => { this.handleError.redirectUrl(error); });
    }

    editarCampos() {
        this.editar = false;
    }

    cancelarEditarCampos() {
        this.editar = true;
        this.vehiculoDetalleModificado = this.cloneVehiculo(this.vehiculoDetalleOriginal);
        this.vehiculoDetalleModificado.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
        this.cargaModelos(this.vehiculoDetalleModificado.CodMarcaVeh);
        this.cargaVersiones(this.vehiculoDetalleModificado.CodModeloVeh);
    }

    renovarVehiculo() {
        this.vehiculoDetalleModificado.Extras.forEach(a => {
            this.extrasExcluidos.forEach(b => {
                if (b.CodExtra == a.CodExtra) {
                    a.EstadoExtra = 2;
                }
            });
        });
        this.vehiculoDetalleModificado.RenovarDeducible = ((this.dedSi == 1) ? true : false);
        this.vehiculoDetalleModificado.MantenerFormaPago = ((this.formaPagoSi == 1) ? true : false);
        this.vehiculoDetalleModificado.ExtrasInclusion = this.extrasNuevos;
        this.renovacionService.insertarVehiculoRenovacion(this.vehiculoDetalleModificado).subscribe(
            result => {
                if (result) {
                    swal({
                        title: 'Renovación',
                        text: "Recuerde que los datos seran verificados por un ejecutivo, para hacer efectiva su renovación",
                        type: 'success'
                    }).then(function () {
                        window.location.reload(true);
                    });
                } else {
                    swal({
                        title: 'Renovación',
                        text: "A ocurrido un inconveniente al intentar enviar su solicitud",
                        type: 'warning'
                    }).then(function () {
                        this.router.navigate(["/error/500"]);
                    });
                }
            },
            error => { this.handleError.redirectUrl(error); }
        );
    }

    excluirExtra(extra: ExtrasEntity) {
        this.extrasExcluidos.push(extra);
        this.vehiculoDetalleModificado.Extras = this.vehiculoDetalleModificado.Extras.filter(function (el) { return el.CodExtra !== extra.CodExtra; });
    }

    regresarExtraExcluido(extra: ExtrasEntity) {
        this.vehiculoDetalleModificado.Extras.push(extra);
        this.extrasExcluidos = this.extrasExcluidos.filter(function (el) { return el.CodExtra !== extra.CodExtra; });
    }

    incluirExtraNuevo() {
        let codigo = this.extraNuevoModal;
        let valor = this.extrasList.find(function (el) {
            return el.Id == codigo.NombreExtraCod;
        });
        if (this.extraNuevoModal.CodExtra == undefined) {
            let date = new Date();
            this.extraNuevoModal.NombreExtra = valor.Descripcion;
            this.extraNuevoModal.CodExtra = date.getMilliseconds() + date.getFullYear();
            this.extrasNuevos.push(this.extraNuevoModal);
        } else {
            this.extrasNuevos.forEach(function (e1) {
                if (e1.CodExtra == codigo.CodExtra) {

                    e1.Marca = codigo.Marca;
                    e1.Modelo = codigo.Modelo;
                    e1.NombreExtra = valor.Descripcion;
                    e1.ValorExtra = codigo.ValorExtra;
                    e1.NombreExtraCod = codigo.NombreExtraCod;
                }
            });
        }
        this.modal.close();
        this.extraNuevoModal = new ExtrasEntity();
    }
    modalClose() {
        this.modal.close();
        this.extraNuevoModal = new ExtrasEntity();
    }

    eliminarExtraNuevo(extra) {
        this.extrasNuevos = this.extrasNuevos.filter(function (el) { return el.CodExtra !== extra.CodExtra; });
    }

    editarExtraNuevo(extra) {
        this.extraNuevoModal = this.cloneExtra(extra);
        this.modal.open();
    }

    cloneExtra(c: ExtrasEntity) {
        let extra = new ExtrasEntity();
        for (let prop in c) {
            extra[prop] = c[prop];
        }
        return extra;
    }

    cloneVehiculo(c: DetalleVehiculoEntity) {
        let vehiculo = new DetalleVehiculoEntity();
        for (let prop in c) {
            vehiculo[prop] = c[prop];
        }
        return vehiculo;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/renovaciones/renovacion-vehiculo.component.ts